import React, { useState } from "react"
import PropTypes from "prop-types"
import { saveScreener } from "@api/project/files/screeners"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Modal, Status } from "@bitcine/cs-theme"

const CustomFieldsModal = ({ screener, saveScreener, onClose }) => {
  const [customFields, setCustomFields] = useState(screener.custom_fields || [])
  
  const saveCustomFields = (newFields = null) => {
    saveScreener(screener.project_id, screener._id, "custom_fields", newFields || customFields)
  }

  return (
    <Modal open width={3} title='Manage Screener Custom Fields' onClose={onClose}>
      <>
        <div className='bg-gray-6 p2 rounded border border-gray-5 mb2 flex items-center'>
          <div className='material-icons small mr1' style={{ fontSize: '24px' }}>info_outline</div>
          <div>The values defined here will appear in shared screeners.</div>
        </div>
        <Status empty={customFields.length === 0} emptyMessage={{ title: "No custom fields added yet." }}>
          {customFields.map((field, index) => (
            <div key={index} className='mb2 flex items-end p2 bg-gray-6 rounded border border-gray-5'>
              <div className='col-3'>
                <label className='mb1'>Label</label>
                <input
                  className='cs-input col-12'
                  value={field.label}
                  onChange={e => {
                    const newFields = [...customFields]
                    newFields[index].label = e.target.value
                    setCustomFields(newFields)
                  }}
                  onBlur={() => saveCustomFields()}/>
              </div>
              <div className='col-8 pl2'>
                <label className='mb1'>Value</label>
                <input
                  className='cs-input col-12'
                  value={field.value}
                  onChange={e => {
                    const newFields = [...customFields]
                    newFields[index].value = e.target.value
                    setCustomFields(newFields)
                  }}
                  onBlur={() => saveCustomFields()}/>
              </div>
              <div className='col-1 pl2'>
                <span className='material-icons cs-button link' style={{ fontSize: "24px", lineHeight: "32px" }}
                  onClick={() => {
                    const newFields = customFields.filter((_, i) => i !== index)
                    setCustomFields(newFields)
                    saveCustomFields(newFields)
                  }}>
                  delete
                </span>
              </div>
            </div>
          ))}
        </Status>
        <div className='flex justify-end mt3'>
          <button
            className='cs-button small white'
            onClick={() => setCustomFields([...customFields, { label: "", value: "" }])}>
            Add Custom Field
          </button>
        </div>
      </>
    </Modal>
  )
}

CustomFieldsModal.propTypes = {
  screener: PropTypes.object.isRequired,
  saveScreener: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  screeners: state.project.screeners.items,
  status: state.project.screeners.status
})

const mapDispatchToProps = dispatch => ({
  saveScreener: bindActionCreators(saveScreener, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomFieldsModal)